
const serviceStatus = document.querySelector('.service-status');

if(serviceStatus) {

  let lastUpdated = getUserTimezoneDate(serviceStatus.dataset.lastUpdated);
  const $lastUpdated = $('.service-status__header__last-updated');

  $lastUpdated.html('Last updated: <span class="timestamp">' + lastUpdated.format('MM/DD/YYYY h:mm a') + '</span>');

  const $animatedTimer = $('.service-status__header__last-updated-timer__animated');
  $animatedTimer.css('width', '1.6%');

  let animationCount = 1;
  let shouldUpdate = true;

  $(window).on('blur', () => {
    shouldUpdate = false;
  });

  $(window).on('focus', () => {
    shouldUpdate = true;
  });

  let serviceStatusInterval = setInterval(() => {

    if(shouldUpdate) {

      animationCount++;

      let pct = (animationCount / 60) * 100;

      if (pct > 100) {

        pct = 100;
        window.location.reload();
        clearInterval(serviceStatusInterval);

      }

      $animatedTimer.css('width', `${pct}%`);

    }

  }, 1000);

}
